// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"28d16bb9","453":"29eb54ac","455":"93846076"}[chunkId] + ".chunk.js";
};